import React, { useState, useEffect } from 'react';
import SecBanner from '../components/AboutUs/SecBanner.js';
import SecNewsletter from '../components/AboutUs/SecNewsletter.js';
import SecWeDo from '../components/AboutUs/SecWeDo.js';
import SecFeature from '../components/AboutUs/SecFeature.js';
import { 
  getPageDetails,
  getBanners,
  getSteps,
  getSeo
 } from '../actions/site';

 import {Helmet} from "react-helmet";
const AboutUs = () => {
  const [pageId,setPageId] = useState({});
  const [seo,setSeo] = useState({});
  const [page,setPages] = useState({});
  const [banners,setBanners] = useState({});
  const [steps,setSteps] = useState({});

  useEffect(() => {
    // Page
    const loadPageData = async () => {
      try {            
        const data = await getPageDetails({
          slug:'about-us'
        });  
        if(data.status == 200) {
          setPageId(data.data._id)
          setPages(data.data)
        }    
      } catch(err) {
        console.log(err.message);
      }
    }
    loadPageData();

     // Mission Vission
     const loadStepsData = async () => {
      try {            
        const data = await getSteps({
          status:'active',
          type:2
        });  
        if(data.status == 200) {
            setSteps(data.data)
        }    
      } catch(err) {
        console.log(err.message);
      }
  }
  loadStepsData();
  }, [ ]); 

  useEffect(() => {
    //Banners
    const loadBannersData = async () => {
        try {            
          const data = await getBanners({
            type:'page',
            type_id:pageId
          });  
          if(data.status == 200) {
              setBanners(data.data)
          }    
        } catch(err) {
          console.log(err.message);
        }
    }
    loadBannersData();
  },[pageId]);
  useEffect(() => {
    //Seo
    const loadSeoData = async () => {
        try {            
          const data = await getSeo({
            type:'page',
            typeId:pageId,
          });  
          if(data.status == 200) {
              setSeo(data.data)
          }    
        } catch(err) {
          console.log(err.message);
        }
    }
    loadSeoData();
  },[pageId]); 

  return (
    <><Helmet>
    <meta charSet="utf-8" />
    <meta name="title" content={seo?.meta_title}></meta>
    <meta name="author" content={seo?.author}></meta>
    <meta name="keywords" content={seo?.keywords}></meta>
    <meta name="description" content={seo?.description}></meta>
    </Helmet>
      <SecBanner banner={banners[0]} />
      <SecWeDo page={page} />
      <SecFeature mission={steps} />
      <SecNewsletter/>
    </>
  );
};

export default AboutUs;